import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import _ from 'underscore';

import {assert} from 'Asserts';
import {BenchlingState} from 'redux-stores/reduceApp';
import * as RequestTaskSchemaReduxActions from 'requests/schemas/RequestTaskSchemaReduxActions';
import sortRequestTaskSchemas from 'requests/schemas/sortRequestTaskSchemas';
import {
  REQUEST_TASK_SCHEMA_SHAPE,
  REQUEST_TASK_SHAPE,
  RequestTask,
  RequestTaskSchema,
} from 'requests/tasks/RequestTaskConstants';
import SchemaSelector from 'samples/SchemaSelector';
import {CenteredHorizontalThrobber} from 'ui-library/HorizontalThrobber';

const ALL_TASKS_ID = 'ALL_TASKS_ID';

function mapStateToProps(
  state: BenchlingState,
  {requestTasks}: RequestTaskSchemaSelectorProps
): ConnectedProps {
  const {requestTaskSchemasById} = state.models.requests.schemas;
  const requestTaskSchemas = [];
  for (const requestTask of requestTasks) {
    requestTaskSchemas.push(requestTaskSchemasById![requestTask.schemaId]);
  }
  const sortedTaskSchemas = sortRequestTaskSchemas(
    _.unique(requestTaskSchemas, (taskSchema) => taskSchema.id)
  );
  return {requestTaskSchemas: sortedTaskSchemas};
}

interface RequestTaskSchemaSelectorProps {
  selectedTaskSchemaId: string | null;
  onSelectSchema: (schema: RequestTaskSchema | null) => void;
  requestTasks: Array<RequestTask>;
}

interface ConnectedProps {
  requestTaskSchemas: Array<RequestTaskSchema>;
}

interface DispatchProps {
  fetchRequestTaskSchemas: () => Promise<void>;
}

class RequestTaskSchemaSelector extends React.Component<
  RequestTaskSchemaSelectorProps & ConnectedProps & DispatchProps
> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static propTypes: any = {
    selectedTaskSchemaId: PropTypes.string,
    onSelectSchema: PropTypes.func.isRequired,

    requestTasks: PropTypes.arrayOf(REQUEST_TASK_SHAPE.isRequired).isRequired,

    // Props provided by connect
    requestTaskSchemas: PropTypes.arrayOf(REQUEST_TASK_SCHEMA_SHAPE.isRequired),

    // Redux actions
    fetchRequestTaskSchemas: PropTypes.func.isRequired,
  };

  override componentDidMount(): void {
    this.props.fetchRequestTaskSchemas();
  }

  _getSchemaOptions(): Array<RequestTaskSchema | {id: string; name: string}> {
    return [
      {
        id: ALL_TASKS_ID,
        name: 'All',
      },
      ...this.props.requestTaskSchemas,
    ];
  }

  override render(): JSX.Element {
    if (this.props.requestTaskSchemas == null) {
      return <CenteredHorizontalThrobber />;
    }

    return (
      <SchemaSelector
        onChange={(schema: RequestTaskSchema) => {
          assert(schema != null, 'SchemaSelector sent a null tagSchema');
          this.props.onSelectSchema(schema.id === ALL_TASKS_ID ? null : schema);
        }}
        schemas={this._getSchemaOptions()}
        selectedSchemaId={
          this.props.selectedTaskSchemaId == null ? ALL_TASKS_ID : this.props.selectedTaskSchemaId
        }
      />
    );
  }
}

export default connect(mapStateToProps, {fetchRequestTaskSchemas: RequestTaskSchemaReduxActions.fetchAll})(
  RequestTaskSchemaSelector
);
